import React, { Component } from "react";
import PayOrderForm from "../PayOrderForm/PayOrderForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : EmployesForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente Employes
================================================================================ */
class PayOrderPage extends Component{
    render(){
        return(
            <div>          
                <PayOrderForm/>
            </div>
        )   
    }
}

export default PayOrderPage;